const notProtectedRoutes = ['/403', '/', '/cleaning_table', '/time_rent_cleaning_table']
export default notProtectedRoutes
